<template>
    <div class="input-group">
      <div class="input-group-prepend">
          <span class="input-group-addon">$</span>
      </div>
      <input
        ref="inputField" 
        v-bind:type="type"
        class="form-control"
        v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)"
        v-bind:placeholder="placeholder"
        v-bind:class="{'is-invalid': hasError(), 'input-sm': isSmall()}"
        @keydown.enter="$emit('enter', $event)"
        @keydown.tab="$emit('tab', $event)"
        :readonly="readonly" />
      <div v-if="addon || addonSlot" class="input-group-append">
        <span class="input-group-addon" v-if="addon" v-html="addon" />
        <slot name="addon"></slot>
      </div>
      <div class="form-invalid-feedback" v-if="hasError()">
        {{getError()}}
      </div>
      <span v-if="!hasError() && note" class="form-field-note">{{note}}</span>
    </div>
</template>

<script>
import formField from '@/mixins/formField'

export default {
  name: "FormInputCurrency",
  mixins: [formField],
  props: {
    type: {
      type: String,
      default: 'number'
    },
    size: {
      type: String,
      default: 'regular'
    },
    value: [String, Number],
    placeholder: String,
    addon: String,
    addonSlot: Boolean,
    readonly: Boolean,
    field: String,
    note: String
  },
  watch: {
    value: function(newVal, oldVal) {
      // Default to empty string if null given
      if(newVal == null) {
        this.$nextTick(() => {
          this.$emit('input', '')
        })
      }
    }
  },
  mounted() {
  },
  methods: {
    hasError() {
      return this.getFieldError(this.$props.field).length > 0
    },
    getError() {
      return this.getFieldError(this.$props.field)
    },
    isSmall() {
      return this.size == 'small'
    },
    focus() {
      this.$refs.inputField.focus()
    },
    select() {
      this.$refs.inputField.select()
    },
    blur() {
      this.$refs.inputField.blur()
    },
  }
};
</script>